import { Routes, Route } from "react-router-dom"
import { SmoothScroll } from "@/components/smooth-scroll"
import HomePage from "@/pages/home-page"

export default function App() {
  return (
    <>
      <div className="noise-overlay" aria-hidden="true" />
      <SmoothScroll>
        <Routes>
          <Route path="/" element={<HomePage />} />
        </Routes>
      </SmoothScroll>
    </>
  )
}
